import { io, type Socket } from "socket.io-client";

class SocketService {
    private socket: Socket | null = null;

    constructor() {
        this.socket = null;
    }

    connect({ onConnected, onDisconnected }: { onConnected?: () => void; onDisconnected?: () => void }): Socket {
        this.socket = io(import.meta.env.VITE_WS_BASE_URL, {
            autoConnect: false,
            withCredentials: true,
            forceNew: true,
            multiplex: false,
            transports: ["websocket", "polling"],
        });

        this.socket.on("connect", () => {
            onConnected?.();
        });

        this.socket.on("disconnect", () => {
            onDisconnected?.();
        });

        this.socket.connect();

        return this.socket;
    }

    disconnect() {
        if (this.socket) {
            this.socket.disconnect();
            this.socket = null;
        } else {
            console.warn("No socket to disconnect");
        }
    }

    getSocket() {
        return this.socket;
    }
}

export default new SocketService();
